module.exports = require('./helpers/bundle-url').getBundleURL('el9ZH') + "logo.c51670a8.svg";